import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ProductDetail from "./ProductDetail";
import Loader from "../../Components/Common/Loader";
import { getProductById as onGetProductById } from "../../slices/thunks";

const ProductDetailPage = () => {
  const { pro_id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const product = useSelector((state) => state.Products?.product);

  useEffect(() => {
    if (pro_id) {
      dispatch(onGetProductById({ pro_id }));
    }
  }, [dispatch, pro_id]);

  if (!product) return <Loader />;

  return (
    <ProductDetail
      show={true}
      product={product}
      onClose={() => navigate("/products")}
    />
  );
};

export default ProductDetailPage;
